import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "google/type/date.proto" (package "google.type", syntax proto3)
// tslint:disable
//
// Copyright 2016 Google Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
//
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime"; // @generated message type with reflection information, may provide speed optimized methods

var Date$Type = /*#__PURE__*/function (_MessageType) {
  _inherits(Date$Type, _MessageType);

  var _super = _createSuper(Date$Type);

  function Date$Type() {
    _classCallCheck(this, Date$Type);

    return _super.call(this, "google.type.Date", [{
      no: 1,
      name: "year",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }, {
      no: 2,
      name: "month",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }, {
      no: 3,
      name: "day",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }]);
  }
  /**
   * Creates a javascript Date object from the message.
   *
   * If you do not provide the optional parameters for time,
   * the current time is used.
   */


  _createClass(Date$Type, [{
    key: "toJsDate",
    value: function toJsDate(message, hours, minutes, seconds, ms) {
      var now = new globalThis.Date();
      return new globalThis.Date(message.year, message.month - 1, message.day, hours !== null && hours !== void 0 ? hours : now.getHours(), minutes !== null && minutes !== void 0 ? minutes : now.getMinutes(), seconds !== null && seconds !== void 0 ? seconds : now.getSeconds(), ms !== null && ms !== void 0 ? ms : now.getMilliseconds());
    }
    /**
     * Creates a Date message from a javascript Date object.
     */

  }, {
    key: "fromJsDate",
    value: function fromJsDate(date) {
      return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
    }
  }, {
    key: "create",
    value: function create(value) {
      var message = {
        year: 0,
        month: 0,
        day: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
            _reader$tag2 = _slicedToArray(_reader$tag, 2),
            fieldNo = _reader$tag2[0],
            wireType = _reader$tag2[1];

        switch (fieldNo) {
          case
          /* int32 year */
          1:
            message.year = reader.int32();
            break;

          case
          /* int32 month */
          2:
            message.month = reader.int32();
            break;

          case
          /* int32 day */
          3:
            message.day = reader.int32();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* int32 year = 1; */
      if (message.year !== 0) writer.tag(1, WireType.Varint).int32(message.year);
      /* int32 month = 2; */

      if (message.month !== 0) writer.tag(2, WireType.Varint).int32(message.month);
      /* int32 day = 3; */

      if (message.day !== 0) writer.tag(3, WireType.Varint).int32(message.day);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return Date$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message google.type.Date
 */


export var Date = new Date$Type();